import base from '../Base';

const themeColor = {
  // color
  primary: '#B9B309',
  // primary: '#3bbec0',
  // primary: '#77bb1f',

  secondary: '#00457C',
  // secondary: '#333333',
  // secondary: '#57585b',

  // used for inner elements-specific to theme
  theme: '#00457C',
  // theme: '#77bb1f'
  // theme: '#333333'
};

const logo = {
  width: 0,
  height: 0,
  left: 32,
  top: 36,
  mobileWidth: 0,
  pageTileMarginTop: 0,
};

const dashboard = {
  driver: 'linear-gradient(180deg, #959595 0%, #57585B 100%)',
  vehicle: 'linear-gradient(180deg, #A5E157 0%, #77BB1F 100%)',
};

const theme = {
  ...base,
  color: { ...base.color, ...themeColor },
  dashboard,
  logo,
};

export default theme;



// WEBPACK FOOTER //
// ./src/themes/themes/iframes/FleetPartners.js